module.exports = __webpack_public_path__ + "static/media/doorTitle.6fa24e5c.jpg";